module.exports = __webpack_public_path__ + "static/media/Lin-nb.1c9cfa4c.jpg";